import { Component, Input, ViewEncapsulation } from '@angular/core';
import { MainTitle, TitleCardVariant } from "../../main-title/main-title.component";
import { MediaPictureService } from 'projects/common/services/media-picture.service';
import { UpaService, UpaTarget } from 'projects/common/services/upa.service';

@Component({
  selector: 'title-card',
  template: `
    <ng-container [ngSwitch]="data.title_card_variant">
      
      <a *ngSwitchCase="TitleCardVariant.ACCESS_POINT"
         [href]="data.card_link"
         (click)="trackTitleCardClick()"
         target="_blank"
         rel="noopener noreferrer"
         class="title-card-access-point eva-3-link eva-3-offer-card eva-3-card -eva-3-shadow-2-hover">
        
        <div class="circle-button">
          <i class="eva-3-icon-arrow-bold-up -eva-3-icon-md"></i>
        </div>

        <img *ngIf="data.card_image && mediaPictureService.getMediaUrl(data.card_image.src) as imageSrc"
             [src]="imageSrc" 
             [alt]="data.card_image.alt || ''"
             class="card-illustration">
        
        <div class="card-content">
          <tag-text [data]="data.pre_title" class="card-pretitle -eva-3-mb-sm"></tag-text>
          <tag-text [data]="data.title" class="card-title"></tag-text>
        </div>
      </a>

      <div *ngSwitchDefault 
           class="title-card-container eva-3-offer-card eva-3-card -eva-3-shadow-line -eva-3-shadow-2-hover">
        <tag-text [data]="data.pre_title" class="-eva-3-mb-sm"></tag-text>
        <tag-text [data]="data.title" class="-eva-3-mb-sm"></tag-text>
        <tag-text [data]="data.sub_title"></tag-text>
      </div>
      
    </ng-container>
  `,
  styleUrls: ['./title-card.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TitleCardComponent {
  @Input() data: MainTitle;
  @Input() module: any;
  @Input() moduleIndex: number;

  readonly TitleCardVariant = TitleCardVariant;

  constructor(
    public mediaPictureService: MediaPictureService,
    private upaService: UpaService
  ) {}

  trackTitleCardClick() {
    const dataToTrack = {
      label: this.data.title?.text,
      moduleId: this.module.id,
      moduleIndex: this.moduleIndex,
      uniqueId: this.module.unique_id,
      target: UpaTarget.CARD,
      href: this.data.card_link
    };
    this.upaService.trackClickTopic(dataToTrack);
  }
}
